// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__xr39h","control":"Checkout_control__EiZTI","actions":"Checkout_actions__7S3hs","submit":"Checkout_submit__fWcCG","invalid":"Checkout_invalid__Xl1rR"};